module.exports = __webpack_public_path__ + "assets/img/mecha-5deb1de5.png";